module.exports = __webpack_public_path__ + "images/product-navigation/starter-kit-a41c2e07.svg";